<!-- ----------------------------------------------- -->
<template>
  <v-card class="com-pc-card tm-pc-detail-config-card">
    <v-row class="com-pc-card-header">
      <span class="com-pc-card-title">{{ panel.display }}</span>
    </v-row>
    <v-col class="com-pc-card-contents">
      <v-row no-gutters>
        <span class="px-2" v-if="isDispGraph()">
          <v-btn
            tile
            depressed
            small
            class="mt-1"
            color="success"
            min-width="50px"
            max-width="50px"
            :outlined="timeMode === false"
            @click="timeMode = true"
            >{{ btn.timehour }}</v-btn
          >
          <v-btn
            tile
            depressed
            small
            class="mt-1"
            color="success"
            min-width="50px"
            max-width="50px"
            :outlined="timeMode === true"
            @click="timeMode = false"
            >{{ btn.time10 }}</v-btn
          >
        </span>
        <span class="px-2" v-if="isDispGraph()">
          <v-btn
            tile
            depressed
            small
            class="mt-1"
            color="success"
            min-width="50px"
            max-width="50px"
            :outlined="scalMode === true"
            @click="scalMode = false"
            >{{ btn.zoomout }}</v-btn
          >
          <v-btn
            tile
            depressed
            small
            class="mt-1"
            color="success"
            min-width="50px"
            max-width="50px"
            :outlined="scalMode === false"
            @click="scalMode = true"
            >{{ btn.zoomin }}</v-btn
          >
        </span>
      </v-row>
    </v-col>
    <v-row class="com-pc-card-header">
      <span class="com-pc-card-title">{{ panel.contents }}</span>
      <span class="com-pc-legend-btn" v-if="isDispGraph()">
        <v-btn
          depressed
          x-small
          class="ma-1"
          color="orange"
          max-width="70px"
          dark
          :outlined="!isLegendDisp"
          @click="isLegendDisp = !isLegendDisp"
        >
          {{ btn.legend }}
          <span v-if="isLegendDisp">{{ btn.legendOn }}</span>
          <span v-else>{{ btn.legendOff }}</span>
        </v-btn>
      </span>
    </v-row>
    <v-col class="com-pc-card-contents">
      <v-checkbox
        v-model="obsDispStatus.info"
        :label="contents.info"
        class="ma-0"
        hide-details
        v-if="this.detailInfoList && this.detailInfoList.length > 0"
      ></v-checkbox>
      <v-checkbox
        v-model="obsDispStatus.obsGraph"
        :label="contents.rainGraph"
        class="ma-0"
        hide-details
      ></v-checkbox>
      <v-checkbox
        v-model="obsDispStatus.valuesList"
        :label="contents.valuesList"
        class="ma-0"
        hide-details
      ></v-checkbox>
    </v-col>
    <v-row class="com-pc-card-header">
      <span class="com-pc-card-title">{{ panel.sns }}</span>
    </v-row>
    <v-col class="com-pc-card-contents">
      <tm-detail-sns></tm-detail-sns>
    </v-col>
  </v-card>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 [PC]雨量 表示切替カード
 * TmRainDetailConfig.vue
 * @author ILUKE
 */
import TmDetailSns from "./TmDetailSns.vue";
export default {
  name: "tm-rain-detail-config",
  components: {
    TmDetailSns,
  },
  data() {
    return {
      panel: {
        display: "表示切替",
        legend: "凡例",
        contents: "表示内容切替",
        sns: "SNS投稿",
      },
      contents: {
        info: "お知らせ情報",
        rainGraph: "雨量グラフ",
        valuesList: "観測値一覧",
      },
      btn: {
        timehour: "時間毎",
        time10: "10分毎",
        zoomout: "全体",
        zoomin: "拡大",
        legend: "凡例",
        legendOn: "(on)",
        legendOff: "(off)",
      },
    };
  },
  computed: {
    /** 雨量情報 */
    tmRainList: {
      get() {
        return this.$store.state.Telemeter.selectedTm;
      },
    },
    /** 拡縮表示設定 */
    scalMode: {
      get() {
        return this.$store.state.Telemeter.scalMode;
      },
      set(val) {
        this.$store.commit("Telemeter/setScalMode", val);
      },
    },
    /** 表示時刻設定 */
    timeMode: {
      get() {
        return this.$store.state.Telemeter.timeMode;
      },
      set(val) {
        this.$store.commit("Telemeter/setTimeMode", val);
      },
    },
    /** 凡例表示状態 */
    isLegendDisp: {
      get() {
        return this.$store.state.Telemeter.isLegendDisp;
      },
      set(val) {
        this.$store.commit("Telemeter/setLegendDisp", val);
      },
    },
    /** コンテンツ切替 */
    obsDispStatus: {
      get() {
        return this.$store.state.Telemeter.obsDispStatus;
      },
    },
    /** お知らせ情報 */
    detailInfoList() {
      return this.$store.state.map.information;
    },
  },
  methods: {
    isDispGraph() {
      if (
        this.tmRainList.length !== 0 &&
        (this.tmRainList.graph.hour.value.length > 0 ||
          this.tmRainList.graph.min10.value.length > 0)
      ) {
        return true;
      }
      return false;
    },
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped>
.com-pc-card-header {
  .com-pc-legend-btn {
    position: absolute;
    right: 0;
  }
}
</style>
